import React, { Component } from 'react';
import {Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import FlatButton from "material-ui/FlatButton/index";
import ContentCreate from "material-ui/svg-icons/content/create";
import {TextInput} from "components/input";
import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';

import FromTimestampToDateField from 'util/fields/FromTimestampToDateField';
import {saveDataRecordSelected} from "actions/recordSelectedActions";

import * as urls from "./urls";
import * as utils from './utils';
import { ShopDisableResourceName } from "./resources";


const ShopDisableListFilter = (props) => (
  <FilterForm {...props} initialValues={ props.defaultSearchValue }>
    <TextInput source="mobile_number" label="Mobile"/>
  </FilterForm>
);

class DisableButton extends Component {
  constructor(props) {
    super(props);
    this.saveCurrentShopData = this.saveCurrentShopData.bind(this);
  }

  saveCurrentShopData() {
    const { record } = this.props;
    this.props.dispatch(saveDataRecordSelected(ShopDisableResourceName, record));
  }

  render() {
    const {record} = this.props;
    if (!record.enabled) {
      return null;
    }

    return (
      <div onClick={this.saveCurrentShopData}>
        <FlatButton
          primary
          label='Delete'
          icon={<ContentCreate />}
          containerElement={<Link to={ urls.shopDisableRequestFrontendPath} />}
          style={{ overflow: 'inherit' }}
        />
      </div>
    )
  }
}
const DisableButtonConnected = connect()(DisableButton);

const CustomField = (props) => {
  const { source, record } = props;
  const newRecord = {};
  if (record[source]) {
    newRecord[source] = 'Enabled';
  } else {
    newRecord[source] = 'Deleted';
  }

  newRecord['rental_status'] = utils.generateRentalStatus(record);

  return (
    <TextField {...props} record={newRecord}/>
  );
};


class ShopDisableList extends Component {
  render() {
    const {filterValues} = this.props;
    let autoLoadData = false;
    if (filterValues && Object.keys(filterValues).length > 0) {
      autoLoadData = true;
    }

    return (
      <List
        {...this.props}
        title="Delete Branch From Chain"
        autoLoadData={autoLoadData}
        filters={<ShopDisableListFilter defaultSearchValue={filterValues} />}
      >
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="shop_id" label="Shop ID"/>
          <TextField source="owner_mobile_no" label="Owner mobile"/>
          <TextField source="shop_name" label="Shop name"/>
          <FromTimestampToDateField source="created_at" label="Create Date"/>
          <CustomField source="rental_status" label="Rental Status"/>
          <TextField source="last_updated_by" label="Last Updated By"/>
          <CustomField source="enabled" label="Status" />
          <DisableButtonConnected label="Delete" />
        </Datagrid>
      </List>
    )
  }
}

export default connect(
  state => ({
    filterValues: state.admin.filter[ShopDisableResourceName],
    shopData: state.admin[ShopDisableResourceName].data,
  })
)(ShopDisableList);



// WEBPACK FOOTER //
// ./src/routes/shop/ShopDisableList.js